import { FC } from 'react';
import { IListCheckEntry } from 'src/ts/interfaces/listCheck';
import { listCheckChip, partitionListChecks } from '../../helpers/listCheckHelpers';
import { ListCheckGroupLabel, ListCheckRow, ListCheckRowName } from '../../styles';
import ListCheckChip from '../ListChecksPanel/ListCheckChip';
import { CheckList, RailMutedText, RailSections, RailStatusRow } from './styles';

interface IProps {
  rulings?: IListCheckEntry[] | null;
  isLoadingRulings?: boolean;
  selectedCheckKey?: string | null;
  onSelectCheck?: (checkKey: string) => void;
}

const CheckRail: FC<IProps> = ({
  rulings = null,
  isLoadingRulings = false,
  selectedCheckKey = null,
  onSelectCheck
}) => {
  const { needsReview, reviewed, cleared } = partitionListChecks(rulings ?? []);

  const renderRow = (entry: IListCheckEntry, quiet: boolean) => {
    const isSelected = selectedCheckKey === entry.check_key;
    const chip = listCheckChip(entry);
    return (
      <ListCheckRow
        key={entry.check_key}
        type="button"
        id={`inspector-list-check-row-${entry.check_key}`}
        data-testid={`inspector-list-check-row-${entry.check_key}`}
        $active={isSelected}
        $quiet={quiet}
        aria-pressed={isSelected}
        onClick={() => onSelectCheck?.(entry.check_key)}
      >
        <ListCheckRowName>{entry.display_name}</ListCheckRowName>
        {chip && <ListCheckChip chip={chip} />}
      </ListCheckRow>
    );
  };

  return (
    <CheckList data-testid="inspector-check-list">
      {isLoadingRulings && (
        <RailSections role="status" data-testid="inspector-list-checks-loading">
          <RailStatusRow>
            <RailMutedText>Loading list checks…</RailMutedText>
          </RailStatusRow>
        </RailSections>
      )}
      {rulings && rulings.length === 0 && (
        <RailSections data-testid="inspector-list-checks-none">
          <RailStatusRow>
            <RailMutedText>No list checks for this document.</RailMutedText>
          </RailStatusRow>
        </RailSections>
      )}
      {rulings && rulings.length > 0 && (
        <RailSections data-testid="inspector-list-check-sections">
          {needsReview.length > 0 && (
            <ListCheckGroupLabel $needs>Needs review ({needsReview.length})</ListCheckGroupLabel>
          )}
          {needsReview.map((entry) => renderRow(entry, false))}
          {reviewed.length > 0 && (
            <ListCheckGroupLabel>Reviewed ({reviewed.length})</ListCheckGroupLabel>
          )}
          {reviewed.map((entry) => renderRow(entry, true))}
          {cleared.length > 0 && (
            <ListCheckGroupLabel>Cleared ({cleared.length})</ListCheckGroupLabel>
          )}
          {cleared.map((entry) => renderRow(entry, true))}
        </RailSections>
      )}
    </CheckList>
  );
};

export default CheckRail;
